import React from 'react'

import Icon, { Props } from './Icon'

const IconLightbulp: React.FC<Props> = (props) => {
  return (
    <Icon title="" viewBox="0 0 17.861 28.578" {...props}>
      <path d="M8.931 0a8.93 8.93 0 00-6.314 15.245 8.875 8.875 0 012.4 4.4h7.83a8.869 8.869 0 012.4-4.4A8.93 8.93 0 008.933 0zm-3.16 11.039l-1.059 1.059a.265.265 0 01-.383-.005 4.755 4.755 0 010-6.323.265.265 0 01.383-.006l1.059 1.058a2.982 2.982 0 000 4.218zM12.629 22.326h-7.4v2.553a3.7 3.7 0 107.4 0v-2.553z" />
    </Icon>
  )
}

export default IconLightbulp
